import { FC, useContext, useMemo, useRef } from 'react';
import { Button, Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { titleUpperCase } from '@lhb/func';
import styles from './index.module.less';
import { MainAppContext } from '@/index';
import { ButtonProps } from 'antd/lib/button/button';

export interface OperateButtonProps extends ButtonProps {
  name: string;
  event: string;
  position?: 'front'; // 收起的位置，默认为end
  hide?: boolean;
}

export interface OperateProps {
  operateList: OperateButtonProps[]; // 操作按钮列表
  showBtnCount?: number;
  onClick?: Function;
}
export interface Permission {
  event: string;
  name: string;
}

export interface FormattingPermission extends Permission {
  isBatch: boolean;
  text: string;
  func: string;
  type?: boolean;
  disabled?: boolean;
}


function refactorPermissions(permissions, filterKeys?: Array<string>) {
  const result: any = [];
  if (!(Array.isArray(permissions) && permissions.length)) return result;
  permissions.forEach((item) => {
    if (!item || !item.event) {
      return;
    }
    const lastIndexOf = item.event.lastIndexOf(':');
    const eventName = item.event.slice(lastIndexOf + 1);
    if (filterKeys && filterKeys.length && filterKeys.includes(eventName)) {
      return;
    }
    result.push({
      ...item,
      text: item.name,
      isBatch: eventName.indexOf('batch') > -1,
      event: eventName,
      func: titleUpperCase(eventName),
    });
  });
  return result;
}



const Operate: FC<OperateProps> = ({ operateList, showBtnCount = 3, onClick }) => {
  const { container } = useContext(MainAppContext);
  // 平铺的按钮
  const showOperate = useMemo(() => {
    operateList = operateList.filter(item => !item.hide);
    return refactorPermissions(operateList).filter((item) => item.position !== 'front').slice(0, showBtnCount - 1);
  }, [operateList, showBtnCount]);

  const operateRef = useRef<any>();

  // 更多的按钮显示在前面或者后面(默认为false，显示在最后)及更多的样式（默认为link）
  const { moreBtnPosition, moreBtnType = 'link' } = useMemo(() => {
    if (operateList.length) {
      const btnPosition = operateList.findIndex((item) => item.position === 'front');
      const len = operateList.length - 1;
      const moreItemType = btnPosition !== -1 ? operateList[btnPosition].type : operateList[len].type;
      return {
        moreBtnPosition: btnPosition !== -1,
        moreBtnType: moreItemType,
      };
    } else {
      return {
        moreBtnPosition: false,
        moreBtnType: 'link',
      };
    }
  }, [operateList]);

  // 需要折叠的按钮
  const dropDownOperate = useMemo(() => {
    // 小于则没有下拉
    if (operateList.length < showBtnCount) {
      return [];
    }
    const frontList = operateList.filter((item) => item.position === 'front');
    // 如果有位置为front的操作
    if (frontList.length) {
      return operateList.filter((item) => item.position === 'front');
    } else {
      return operateList.slice(showBtnCount - 1, operateList.length);
    }
  }, [operateList, showBtnCount]);

  const handleMenuClick = ({ key }) => {
    // const targetPermission = operateList.find((permission) => permission.event === key);
    // targetPermission && onClick && onClick(targetPermission);
    onClick?.(key);
  };

  const menuList = useMemo(() => {
    return refactorPermissions(dropDownOperate).map((item) => ({
      label: item.name,
      key: item.event || item.name,
    }));
  }, [dropDownOperate]);

  return (
    <>
      <div className={styles.operateContainer} ref={operateRef}></div>
      <div className={styles.operateBtns}>
        {/* 更多按钮显示在前面 */}
        {moreBtnPosition && (
          <Dropdown menu={{ items: menuList, onClick: handleMenuClick }} >
            <Button style={{ marginRight: '8px' }} type={moreBtnType || 'link'}>
              操作 <DownOutlined />
            </Button>
          </Dropdown>
        )}
        <Space>
          {showOperate.map((item) => {
            return (
              <Button
                key={item.event || item.name}
                type={item.type || 'link'}
                icon={item.icon}
                // size={item.size}
                disabled={item.disabled}
                loading={item.loading}
                // 如果有onClick事件则直接调用onClick事件，没有则调用统一的onClick事件
                onClick={item.onClick ? item.onClick : () => handleMenuClick({ key: item.event })}
              >
                {item.name}
              </Button>
            );
          })}
          {!moreBtnPosition && !!dropDownOperate.length && (
            <Dropdown menu={{ items: menuList, onClick: handleMenuClick }}
              getPopupContainer={() => {
                return (container || document)?.querySelector('#popContainer');
              }}
            >
              <Button type={moreBtnType || 'link'}>
                操作 <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Space>
        {/* 更多按钮位置 */}
      </div>
    </>
  );
};

export default Operate;
